import * as React from "react";
import {defineMessages, InjectedIntlProps, injectIntl} from "react-intl";
import {LcdIcon} from "../icon/LcdIcon";

const MESSAGES = defineMessages({
  CLOSE: {
    id: "studio.ui.alert.close",
    defaultMessage: "Close"
  }
});

export type AlertType = "success" | "error" | "warning";

interface AlertBoxProps {
  type: AlertType;
  message: string;
  onClose?: () => void;
}

const getValidationStateIcon = (type: AlertType) => {
  switch (type) {
  case "success":
    return (
        <div className="icon icon-success">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="svg-success-check-icon"
          >
            <path
                d="M9 16.17L4.83 12l-1.41 1.41L9 19 21 7l-1.41-1.41z"
                fill="white"
                stroke="white"
                strokeWidth="2"
            />
          </svg>
        </div>
    );
  case "error":
    return <div className="icon icon-error"><LcdIcon icon="exclamation"/></div>;
  case "warning":
    return <div className="icon-warning"></div>;
  }
}

const getCSSClass = (type: AlertType) => {
  switch (type) {
  case "success":
    return "alert-box-bg-color-success";
  case "error":
    return "alert-box-bg-color-error";
  case "warning":
    return "alert-box-bg-color-warning";
  default:
    return "";
  }
};

class AlertBoxComponent extends React.Component<AlertBoxProps & InjectedIntlProps> {
  handleAlertBoxClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const {type, message, intl} = this.props;

    return (
        <div className={`alert-box ${getCSSClass(type)}`}>
          <div className="alert-box-icon-wrapper">
            {getValidationStateIcon(type)}
          </div>
          <div className="alert-box-content">
            <div className="alert-box-message-wrapper">
              <span className="alert-box-message">{message}</span>
            </div>
            <div className="alert-box-close-wrapper">
              <button
                  className="alert-box-close-button"
                  onClick={this.handleAlertBoxClose}
                  title={intl.formatMessage(MESSAGES.CLOSE)}
              >
                <LcdIcon icon="close-box-outline"/>
              </button>
            </div>
          </div>
        </div>
    );
  }
}

export const AlertBox = injectIntl(AlertBoxComponent);